//Componentes generales
import { useEffect, useState, useContext } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import Select from 'react-select';

// Alertas
import Swal from 'sweetalert2'

//Estilos
import './FormNivel5.css';
import { PRINCIPAL, NAVBARS, COLOR_BTN, COLOR_BOTONES } from '../../constants/colors';

//Contextos
import nivel5Context from '../../context/nivel5Context/nivel5Context';
import activoContext from '../../context/activoContex/activoContex';
import { createEstructuraNivel1, estructuraNivel1, estructuraNivel4 } from '../../utils/estructuras';
import DictionaryText from '../dictionaryText/DictionaryText';
import authContext from '../../context/authentication/authContex';
import clienteAxios from '../../config/axios';

/*
    Componente encargado de mostrar el formulario de usuario.
        Donde data es el usuario crear/modificar.
              minimizar es la función encargada de ocultar el dialogo.
              generar es la función del context que guarda el usuario.
              titulo es la que determina que texto mostrar en encabezado del dialogo.
              verficaUser es la función del context que comprueba la licencia por usuario vigente del cliente.
*/
function FormNivel5({ data,setData, minimizar, formDato, nuevoEditado, i, handleChangeUbicaciones, generar = () => console.log("Generando"), listaUsuarios = [], optionsNivel4, nivel4Lista, nivel4Seleccionado, modo }) {
    
    // context agregarActivo - modificarrActivo
    const {actualizaractivoList} = useContext(activoContext)

    const pContext = useContext(nivel5Context);
    const {agregarNivel5, actualizarNivel5List, modificarNivel5, eliminarNivel5} = pContext;

    //State de usuario. Si no viene data por parametro significa que es nuevo por lo que se le asigna una estructura.
    const [nivel5, setNivel5] = useState((data !== undefined && nuevoEditado == 'Modificar') ? {group: {codNivel5:data?.codNivel5, name: data?.name, descrp:data?.descrp, codNivel4: nivel4Seleccionado?.codNivel4, id: data?.id, direccion: data?.direccion || '', lat: data?.lat || null, lng: data?.lng || null}} : {group: {codNivel5:"", name:"", descrp:"",codNivel4: nivel4Seleccionado.codNivel4, direccion: '', lat: null, lng: null}, members: []});
    const [opcionSeleccionada, setOpcionSeleccionada] = useState(null);

    const {getValorActualFromDictionary} = useContext(authContext);

    //nivel4Seleccionado tengo que agregarle el value y el label para que se vean.
    const nivel4SeleccionadaNormalizada = {
        value: nivel4Seleccionado?.name || nivel4Seleccionado?.label,
        label: nivel4Seleccionado?.name || nivel4Seleccionado?.label,
        // Resto de las propiedades que quieras copiar
        codNivel4: nivel4Seleccionado?.codNivel4,
        descrp: nivel4Seleccionado?.descrp,
        id: nivel4Seleccionado?.id,
        
    };

    const nivel4SeleccionadaValuo = nivel4Seleccionado?.value !== undefined ? 
                  {...nivel4Seleccionado, value: nivel4Seleccionado.name, label: nivel4Seleccionado.name } 
                  : nivel4Seleccionado

    //Constante que define el titulo que corresponde si vienen datos por parametros
    const [titulo, setTitulo] = useState(nuevoEditado)
   
    //Funcion de validacion
    const validacion =  () => { 
        const newErrors = {};

        if (nivel5.group.codNivel5 === '' || nivel5.group.codNivel5 === undefined) return newErrors.codigo = 'El código debe ser colocado';
        if (nivel5.group.name === '' || nivel5.group.codNivel5 === undefined) return newErrors.nombre = 'El nombre debe ser colocado';
        if (nivel5.group.descrp === '' || nivel5.group.descrp === undefined) return newErrors.nombre = 'La descripción debe ser colocada';

        return '';    
    };

    const handleGeocodificar = async () => {
        try {
            const resp = await clienteAxios.get(`/geocode?address=${encodeURIComponent(nivel5.group.direccion)}`);
            const { lat, lng } = resp.data.data;
            setNivel5({ ...nivel5, group: { ...nivel5.group, lat, lng } });
        } catch (err) {
            Swal.fire({ icon: 'warning', title: 'No se pudo geocodificar',
                text: err.response?.data?.message || 'Verifique la direccion ingresada' });
        }
    };

    // manda los datos al back
    const handlerGenerar = async () => {

        const errorAxi = validacion();

        if (errorAxi === "" ) {

            try {

                const { group } = nivel5;

                // Crea un nuevo objeto sin la propiedad id
                const { id, ...datoSinId } = group;
                //compara el name del Select con el name de la la DB para mandar info a la DB
                const filtro = nivel4Lista?.filter(dato => dato?._id === nivel4SeleccionadaValuo?.id);
                const nivel5Nivel4 = filtro[0]

                const datos = {...datoSinId, nivel5Nivel4}

                const res = await agregarNivel5(datos)
                console.log("res");
                console.log(res);
                if (res !== null) {
                    Swal.fire({
                        title: `Guardado exitosamente!`,
                        icon: 'success',
                        text: `Código: ${res.lv5Saved.codNivel5} \n Nombre: ${res.lv5Saved.name} `,
                        showConfirmButton: true,
                        allowEnterKey: true
                    });
                    actualizaractivoList();
                    actualizarNivel5List();
                    minimizar();
                } else {
                    Swal.fire({
                        title:  "Se esta repitiendo el código o nombre",
                        icon: 'warning',
                        showConfirmButton: true,
                        allowEnterKey: true
                    });
                }
            } catch (error) {
                console.log(error);
            }
        }else{
            Swal.fire({
                title: errorAxi,
                icon: 'warning',
                showConfirmButton: true,
                allowEnterKey: true
            });
        }
    }

    const handlerModificar = async () => {
        const errorAxi = validacion();

        if (errorAxi === "") {
    
            try {
                const dato = {
                    id: nivel5.group.id === undefined ? data._id : nivel5.group.id,
                    codNivel5: nivel5.group.codNivel5,
                    codNivel4:nivel5.group.codNivel4,
                    name: nivel5.group.name,
                    descrp: nivel5.group.descrp,
                    direccion: nivel5.group.direccion,
                    lat: nivel5.group.lat,
                    lng: nivel5.group.lng
                }

                const res = await modificarNivel5(dato);

                if (res !== null) {
                    Swal.fire({
                        title: `Modificado exitosamente!`,
                        icon: 'success',
                        text: `Código: ${res.codNivel5} \n Nombre: ${res.name} `,
                        showConfirmButton: true,
                        allowEnterKey: true
                    });
                    actualizarNivel5List();
                    actualizaractivoList();
                    minimizar({...dato, label: res.name, value: res.name});
                } else {
                    Swal.fire({
                        title:  "Se esta repitiendo el código o nombre",
                        icon: 'warning',
                        showConfirmButton: true,
                        allowEnterKey: true
                    });
                }
            } catch (error) {
                console.log(error);
            }
        }else{
                Swal.fire({
                    title: errorAxi,
                    icon: 'warning',
                    showConfirmButton: true,
                    allowEnterKey: true
                });
        }  
    }

    //lee lo que esta en el Select
    const handleChange = (selectedOption) => {
        setOpcionSeleccionada(selectedOption);
    }

    const handlerEliminar = () => {
        const dato = {
            id: data.id,
            codNivel4:nivel5.group.codNivel4,
            name: nivel5.group.name,
            descrp: nivel5.group.descrp 
        }

        Swal.fire({
            title: `Estas seguro que deseas eliminar ${data.name}?`,
            icon: 'warning',
            text: `Se eliminara permanentemente!`,
            showConfirmButton: true,
            showCancelButton: true, // Habilita el botón de cancelar
            confirmButtonText: 'Borrar',
            cancelButtonText:'No, cancelar',
            allowEnterKey: true

        }).then(async (result) => {
            if (result.isConfirmed) {
              // El usuario hizo clic en "Aceptar"
                const id = data.id
                const resp = await eliminarNivel5(id);

                if(resp === "No se puede borrar la nivel5 porque contiene un Nivel3s") {
                    Swal.fire({
                        title: `No puede eliminarse!`,
                        icon: 'warning',
                        text: `Para poder eliminar no tiene que tener ${getValorActualFromDictionary("Nivel3")}`,
                        showConfirmButton: true,
                        allowEnterKey: true
                        
                    })
                    minimizar({...dato, label: dato.name, value:dato.name});
                }else{
                    Swal.fire({
                        title: `Borrado!`,
                        icon: 'success',
                        text: `Eliminado correctamente!`,
                        showConfirmButton: true,
                        allowEnterKey: true
                    })
                    actualizaractivoList();
                    actualizarNivel5List();
                    minimizar(null);
                    handleChangeUbicaciones({},i,'nivel5',{...createEstructuraNivel1()})
                }
            } else if (result.isDismissed) {
             // El usuario hizo clic en "Cancelar" o en cualquier otro lugar fuera del diálogo
                 minimizar({...dato, label: dato.name, value:dato.name});
            }
            });
    }

    return (
        <div className='container-group-form'>
            <div className='title-form-group' style={{backgroundColor: PRINCIPAL, color:NAVBARS}} >
                {titulo} <DictionaryText text={"Nivel 5"}/>
            </div>

            <div className='container-form'>
                <div className='label-form-group'>Codigo de <DictionaryText text={"Nivel 5"}/>: </div>
                <input disabled={ titulo === "Modificar"} value={nivel5.group.codNivel5} className='label-form-group-data' onChange={data => setNivel5({ ...nivel5, group: {...nivel5.group, codNivel5: data.target.value} })} />
            </div>

            <div className='container-form'>
                <div className='label-form-group'>Nombre: </div>
                <input value={nivel5.group.name} className='label-form-group-data' onChange={data => setNivel5({ ...nivel5, group: {...nivel5.group, name: data.target.value} })} />
            </div>

            <div className='container-form'>
                <div className='label-form-group'>Descripción: </div>
                <textarea className='label-form-group-data' value={nivel5.group.descrp} onChange={data => setNivel5({ ...nivel5, group: {...nivel5.group, descrp: data.target.value} })}/>
            </div>

            <div className='container-form'>
                <div className='label-form-group'>Direccion (opcional): </div>
                <div style={{ display: 'flex', gap: '0.5rem', alignItems: 'center' }}>
                    <input
                        value={nivel5.group.direccion || ''}
                        className='label-form-group-data'
                        style={{ flex: 1 }}
                        placeholder="Ej: Av. Corrientes 1234, CABA"
                        onChange={e => setNivel5({...nivel5, group: {...nivel5.group, direccion: e.target.value, lat: null, lng: null}})}
                    />
                    {nivel5.group.direccion && !nivel5.group.lat && (
                        <button type="button" className="geocodeBtnOPD" onClick={handleGeocodificar}>Validar</button>
                    )}
                    {nivel5.group.lat && <span style={{ color: 'green', fontSize: '0.8rem' }}>&#10003; Validada</span>}
                </div>
            </div>

            <div className='container-form'>
                <div className='label-form-group'><DictionaryText text={"Nivel 4"}/>: </div>
                <Select
                    styles={{
                        input: (base) => ({
                            ...base,
                            width: "100%",
                            padding: ".4rem",
                            borderRadius: ".5rem",
                            fontSize: "1rem",
                            transition: "border-color .5s"
                        })
                    }}
                    isDisabled={true}
                    placeholder="Elija el nivel4 que corresponda..."
                    options={optionsNivel4}
                    value={nivel4SeleccionadaNormalizada}
                    onChange={handleChange}
                    
                />
            </div>

            <div className='container-btn-group'>
                <button className='btn-form-group' style={{backgroundColor: COLOR_BOTONES, color:NAVBARS}} onClick={( titulo !== "Modificar") ? handlerGenerar : handlerModificar}>{titulo}</button>
                {
                    (data !== "") &&(
                        <button className='btn-eliminar-form-group' onClick={handlerEliminar}>Eliminar</button>
                    )

                }
                {
                    titulo === "Modificar" ? (
                        <button className='btn-cancel-form-group' onClick={() => minimizar(data)}>Cancelar</button>
                    ) : (
                        <button className='btn-cancel-form-group' onClick={() => minimizar(formDato.activoNivel5)}>Cancelar</button>
                    )
                }
            </div>
        </div>
    );
}

export default FormNivel5;